enum Roles {
  ALL = '',
  USER = 'user',
  ADMIN = 'admin',
}

export default Roles
